import {gsap} from "../../lib/gsap";

export default class BlockGallerySlider {
	static init() {
		let swipers = document.querySelectorAll('.block-gallery-swiper');

		swipers.forEach( (swiper) => {
			const prev = swiper.querySelector(".gallery-button-prev");
			const next = swiper.querySelector(".gallery-button-next");
			const follower = swiper.closest('.cursor-follower-inner').querySelector('.cursor-follower');

			new Swiper(swiper, {
				slidesPerView: "auto",
				grabCursor: true,
				navigation: {
					prevEl: prev,
					nextEl: next,
				},
				on: {
					touchStart: () => {
						gsap.to(follower, 0.2, {
							scale: 0.2,
							opacity: 0
						});
					},
					touchEnd: () => {
						gsap.to(follower, 0.2, {
							scale: 1,
							opacity: 1
						});
					}
				}
			});
		});
	}
}
